// extracted by mini-css-extract-plugin
export default {"secretSantaContainer":"SecretSantaPage_secretSantaContainer__MrlM2","santaBtn":"SecretSantaPage_santaBtn__oLRPI"};